import { EmptyTextData } from 'library/types';

export const formatOrderName = (number: EmptyTextData, type: EmptyTextData) => {
	if (number == null && type == null) {
		return '';
	}

	if (type == null) {
		return number;
	}

	return `${number}/${type}`;
};
